import type { ReactNode } from 'react';

export const symbol_reset_wrench: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m653-208-46 46q-17 17-42 17.5T522-162q-17-17-17-42.5t17-42.5l46-46q-4-11-6-23t-2-24q0-58 41-99t99-41q9 0 18 1t17 3q11 5 13.5 17t-5.5 20l-43 43q-11 11-11.5 27.5T700-340q12 12 28.5 12t28.5-12l42-43q8-8 20-5.5t17 13.5q2 8 3 17t1 18q0 58-41 99t-99 41q-13 0-24.5-2t-22.5-6ZM480-780q-125 0-212.5 87.5T180-480q0 81 38.5 147.5T320-226v-84q0-13 8.5-21.5T350-340q13 0 21.5 8.5T380-310v160q0 13-8.5 21.5T350-120H190q-13 0-21.5-8.5T160-150q0-13 8.5-21.5T190-180h91q-73-48-117-127t-44-173q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q123 0 216.5 72.5T824-583q4 12-2 22.5T804-546q-12 4-23-2t-15-18q-29-92-107-153t-179-61Z"
		/>
	</svg>
);
